//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import AskReworkPropsWindow from '../Report/AskReworkPropsWindow.vue'
import Request from '../../forms/Request/Request.vue'
import TaskActionButton from './TaskActionButton.vue'
import { taskActions } from './TaskActions.js'
import { convertTime } from '../../components/helpers.js'

export default {
  components: {
    TaskActionButton,
    AskReworkPropsWindow,
    Request
  },
  mixins: [taskActions],
  computed: {
    restrictedExternalUser: function () {
      const user = this.$store.getters.getUser
      return !!(user.restrictedAccess && user.employee && user.employee.external)
    },
    reinforcementActions: function () {
      const request = this.request
      const reinforcement = request.actionsProps.reinforcement
      if (reinforcement) {
        return this.getReinforcementActions({
          id: reinforcement.id,
          state: reinforcement.state,
          requestId: request.requestId,
          requestBPState: request.bpStateId,
          get requestNumber () {
            return request.key && !request.key.startsWith('delta_') ? request.key : request.name && request.name.startsWith('Заявка №') ? request.name.substring('Заявка №'.length) : request.name
          }
        })
      }
      return []
    },
    mobile: function () {
      return this.$store.getters.getUser.view === 'mobile'
    },
    deferredCloseActive: function () {
      return !!(this.request && this.request.startCloseDateTime)
    },
    deferredCloseDateTimeText: function () {
      return convertTime(this.request && this.request.startCloseDateTime)
    }
  },
  methods: {
    /*
      ПРАВИЛА ОТОБРАЖЕНИЯ КНОПОК
    */
    displayInitializeRequestButton: function () {
      const hasAccess = this.$d_hasOperation('createInitiatedRequest') && !this.restrictedExternalUser
      return hasAccess && !(this.request.requestTypeObject && this.request.requestTypeObject.allowSynchronizeRequestState)
    },
    displayCreateSynchronizedRequestButton: function () {
      const hasAccess = this.$d_hasOperation('createInitiatedRequest') && !this.restrictedExternalUser
      return hasAccess && this.request.requestTypeObject && this.request.requestTypeObject.allowSynchronizeRequestState && !this.request.synchronizeSourceRequest && (this.taskStatus === 'BS2' || this.taskStatus === 'BS10')
    },
    displayAuditButton: function () {
      const hasAccess = this.requestRoles.roleDispatcherOrHigher && !this.restrictedExternalUser
      const auditable = !!(this.request._configuration && this.request._configuration.auditable)
      return auditable && hasAccess && (this.taskStatus === 'BS8' || this.taskStatus === 'BS11' || this.taskStatus === 'BS17') && !this.isAudit
    },
    displayCreateReportRoadsButton: function () {
      return this.request.deliveryVIS && this.request.deliveryVIS.key === 'roadsmsk' &&
      this.requestRoles.roleDispatcherOrHigher && this.taskStatus != 'BS0' && this.isAudit === false && !this.hasNotTransmittedFinishReport
    },
    displayCancelWorksExecutionButton: function () {
      return !this.report.closedManually &&
        (this.taskStatus == 'BS5' || this.taskStatus == 'BS6' || this.taskStatus == 'BS14' || this.taskStatus == 'BS15' || (this.taskStatus == 'BS7' && this.report.departureNumber !== 0)) &&
        ((this.report.departureNumber !== 0 && (this.reportRoles.roleAdminOrRoot || this.reportRoles.roleMainExecutor || this.reportRoles.roleContractorDispatcher)) ||
          (this.report.departureNumber === 0 && (this.reportRoles.roleAdminOrRoot || this.reportRoles.roleExecutor)))
    },
    BS2_displayAnalyzeRequestButton: function () {
      return (this.requestRoles.roleDispatcherOrHigher || this.isContractorDispatcher && !!this.request.actionsProps.contractorAssignmentAccess) &&
             (this.taskStatus == 'BS19' || this.taskStatus == 'BS21' || this.taskStatus == 'BS3' || this.taskStatus == 'BS4' || this.taskStatus == 'BS1') && !this.request.synchronizeSourceRequest
    },
    BS4_displayAcceptTaskForExecutionButton: function () {
      return (this.taskStatus == 'BS3' && (this.requestRoles.roleAdminOrRoot || this.requestRoles.roleContractorDispatcher || this.requestRoles.roleExecutor)) && !this.request.synchronizeSourceRequest
    },
    BS5_displayTakeWorkInProgressButton: function () {
      return this.taskStatus == 'BS4' && (this.reportRoles.roleAdminOrRoot || this.reportRoles.roleExecutor || this.reportRoles.roleContractorDispatcher) && !this.request.synchronizeSourceRequest
    },
    BS6_displaySetWorksCompletedButton: function () {
      return (this.taskStatus == 'BS5' || this.taskStatus == 'BS14') && (this.reportRoles.roleAdminOrRoot || this.reportRoles.roleExecutor || this.reportRoles.roleContractorDispatcher) && !this.request.synchronizeSourceRequest
    },
    BS6_displayReturnWorksCompletedButton: function () {
      return this.taskStatus == 'BS7' && !this.report.closedManually && (this.reportRoles.roleExecutor || this.reportRoles.roleContractorDispatcher) && !this.isAuditWorks && !this.request.synchronizeSourceRequest
    },
    BS7_displaySetReadinessForDeliveryOfWorksButton: function () {
      return (this.taskStatus == 'BS6' &&
        (this.reportRoles.roleAdminOrRoot || this.reportRoles.roleExecutor || this.reportRoles.roleContractorDispatcher || (this.reportRoles.roles.dispatcher &&
          (this.report.closedManually === true || this.report.bpStateUser === this.reportRoles.user.login || this.report.bpStateUser === 'root')))) ||
        (this.taskStatus == 'BS15' && (this.reportRoles.roleAdminOrRoot || this.reportRoles.roleExecutor || this.reportRoles.roleContractorDispatcher)) && !this.request.synchronizeSourceRequest
    },
    BS7_displayDeferReportButton: function () {
      // return this.BS7_displaySetReadinessForDeliveryOfWorksButton && this.taskStatus == 'BS6' && !this.isContractorAssigned && this.report.departureNumber !== 0
      return this.report.actionsAccess.deferReportCommon && this.taskStatus == 'BS6' && !this.request.synchronizeSourceRequest
    },
    BS8_displayAcceptWorksButton: function () {
      return this.taskStatus == 'BS7' && (this.reportRoles.roleDispatcherOrHigher || this.reportRoles.roleContractorDispatcher) && !this.request.synchronizeSourceRequest
    },
    BS9_displayReopenRequestButton: function () {
      return !!this.request.actionsProps.BS09_ReopenRequest && !this.request.synchronizeSourceRequest
    },
    BS10_displayRequireAdditionalDepartureButton: function () { // BS10
      if (this.isLastReportDeferred) {
        return false
      }
      if (this.isContractorDispatcher) { // this.reportRoles.roleContractorDispatcher
        return this.request.actionsProps.BS10_contractorDispatcher && this.taskStatus == 'BS8'
      }
      return this.requestRoles.roleDispatcherOrHigher && (this.taskStatus == 'BS8' || this.taskStatus == 'BS9' || this.taskStatus == 'BS11') && !this.isAuditWorks && !this.request.synchronizeSourceRequest
    },
    BS11_displayPutRequestUnderControlButton: function () {
      if (this.isLastReportDeferred) {
        return false
      }
      return this.requestRoles.roleDispatcherOrHigher &&
             (this.taskStatus == 'BS8' || this.taskStatus == 'BS9' ||
             (this.request.additionalDepartureRequired && (this.taskStatus == 'BS2' || this.taskStatus == 'BS3' || this.taskStatus == 'BS4' || this.taskStatus == 'BS13'))) && !this.isAuditWorks && !this.request.synchronizeSourceRequest
    },
    BS12_displayRejectRequestButton: function () {
      return this.request.actionsProps.BS12_RejectRequest
    },
    BS13_displayRejectRequestAsContractorButton: function () {
      return this.request.actionsProps.BS13_RejectRequestAsExecutor && !this.request.synchronizeSourceRequest
    },
    BS14_or_BS15_displayReworkButton: function () {
      return this.taskStatus == 'BS7' && (this.report.stateId == 'PR3' || this.report.stateId == 'PR4') && this.reportRoles.roleDispatcherOrHigher && !this.reportRoles.roleExecutor && !this.request.synchronizeSourceRequest
    },
    BS15_displayReworkReportByExecutorButton: function () {
      return false // !!this.report.actionsAccess.reworkReportByExecutor  см. Task 4965
    },
    BS17_displayCloseRequestButton: function () {
      return this.request.actionsProps.BS17_CloseRequest && !this.request.synchronizeSourceRequest && !this.restrictedExternalUser
    },
    BS18_displayWithdrawRequestButton: function () {
      return this.request.actionsProps.BS18_WithdrawRequest && !this.request.synchronizeSourceRequest
    },
    BS19_displayDelayRequestButton: function () {
      return this.request.actionsProps.BS19_DelayRequest && !this.request.synchronizeSourceRequest
    },
    BS20_displayTransmitRequestButton: function () {
      if (this.isLastReportDeferred) {
        return false
      }
      const transmittable = !!(this.request._configuration && this.request._configuration.transmittable)
      return transmittable && this.request.visId && this.requestRoles.roleDispatcherOrHigher && // this.taskStatus != 'BS0'
             (this.taskStatus == 'BS1' || this.taskStatus == 'BS2' || this.taskStatus == 'BS3' || this.taskStatus == 'BS4' || this.taskStatus == 'BS8' ||
             this.taskStatus == 'BS9' || this.taskStatus == 'BS10' || this.taskStatus == 'BS11' || this.taskStatus == 'BS13' || this.taskStatus == 'BS19') && !this.isAudit && !this.request.synchronizeSourceRequest
    },
    BS21_displayReturnRequestButton: function () {
      return this.request.actionsProps.BS21_ReturnRequest && !this.request.synchronizeSourceRequest
    },
    displayIpAddressButton: function () {
      const user = this.$store.getters.getUser
      if (user.hasSystemRoleStrict('publicationRead')) {
        return false
      }
      return this.request && this.request.serviceObject && this.request.serviceObject.type.key === 'trafficLight' && !this.mobile
    },
    copyPingCommand: function (pingCount) {
      const deviceIp = this.request.serviceObject.deviceIp.split(', ')[0]
      let command
      if (pingCount === 20) {
        const countFlag = this.$d.isWindows() ? '-n' : '-c'
        command = `ping ${countFlag} 20 ${deviceIp}`
      } else {
        command = `ping ${deviceIp}`
      }
      const data = [new window.ClipboardItem({ 'text/plain': new Blob([command], { type: 'text/plain' }) })]
      navigator.clipboard.write(data).then(() => {
        this.$q.notify({
          type: 'positive',
          message: 'Команда ping скопирована в буфер обмена',
          progress: true,
          timeout: 3000
        })
      })
    }
  }
}
